import React from 'react'
import DateInput from '../DocParts/DateInput';
import Input from '../DocParts/Input';
import Button from '../AdminParts/Button';
import {
    caption
} from '../../redux/actions/lang';


const HistoryFilter = ( { props, history } ) => {
    return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", marginTop: "18px" }}>
        
            <div>
            <DateInput
                label={ caption.dateFrom }
                name="dateFrom"
                value={ history.dateFrom }
                onChange={ date => { props.onNameValueChange( "dateFrom", date ); props.onUpdateHistory(); } }
                invalidDateMessage=''
                maxDateMessage=''
                minDateMessage=''
            />
            </div>
            
            <div style={{ marginLeft: "7px" }}>
            <DateInput
                label={ caption.dateTo }
                name="dateTo"
                value={ history.dateTo }
                onChange={ date => { props.onNameValueChange( "dateTo", date ); props.onUpdateHistory(); } }
                invalidDateMessage=''
                maxDateMessage=''
                minDateMessage=''
            />
            </div>
            
            <div style={{ marginTop: "3px" }}>
            <Input
                label={ caption.numberOfLines }
                name="limit"
                value={ history.limit }
                onChange={ e => { props.onChange( e ); props.onUpdateHistory(); } }
            />
            </div>
            
            <div style={{ marginLeft: "7px", marginTop: "7px" }}>
            <Button
                name="update"
                onClick={ props.onUpdateHistory }
                label={ caption.update }
            />
            </div>
            
        </div>
    )
}

export default HistoryFilter;
